// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dc701bfb","239":"8842cf4e","453":"46dc3e92","667":"fd6dbc6e"}[chunkId] + ".chunk.js";
};